// src/portfolio/icons.jsx — activity-bar icons + file-type glyph
import React from 'react';

export const Icon = {
  files: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 4h6l3 3h5v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
    </svg>
  ),
  search: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="6" /><path d="M20 20l-4.3-4.3" />
    </svg>
  ),
  git: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="6" cy="6" r="2.2" /><circle cx="6" cy="18" r="2.2" /><circle cx="18" cy="12" r="2.2" />
      <path d="M6 8v8M8 18h4a4 4 0 0 0 4-4v-2" />
    </svg>
  ),
  bug: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="8" y="7" width="8" height="12" rx="4" />
      <path d="M9 5l1.5 2M15 5l-1.5 2M3 11h4M3 16h4M3 21h4M17 11h4M17 16h4M17 21h4" />
    </svg>
  ),
  user: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="9" r="3.5" /><path d="M5 20c1.2-3 4-5 7-5s5.8 2 7 5" />
    </svg>
  ),
  cog: (p) => (
    <svg viewBox="0 0 24 24" {...p} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19.4 13a7.5 7.5 0 0 0 0-2l2-1.5-2-3.4-2.3.8a7.5 7.5 0 0 0-1.7-1l-.4-2.4h-4l-.4 2.4a7.5 7.5 0 0 0-1.7 1l-2.3-.8-2 3.4 2 1.5a7.5 7.5 0 0 0 0 2l-2 1.5 2 3.4 2.3-.8a7.5 7.5 0 0 0 1.7 1l.4 2.4h4l.4-2.4a7.5 7.5 0 0 0 1.7-1l2.3.8 2-3.4-2-1.5z" />
    </svg>
  ),
};

export const MONO = "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

// File-type glyph: colored letter for md/json/pdf/tsv, arrow for folder
export function FileGlyph({ kind, theme, size = 14 }) {
  const color = {
    md: theme.sx.link,
    json: theme.sx.str,
    pdf: theme.sx.num,
    folder: theme.sx.head,
    tsv: theme.sx.fn,
    sh: theme.sx.key,
  }[kind] ?? theme.dim;
  const label = {
    md: 'M', json: '{ }', pdf: 'P', folder: '▸', tsv: 'T', sh: '$',
  }[kind] ?? '·';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size + 4, height: size + 4, flex: '0 0 auto',
      color, fontFamily: MONO, fontSize: kind === 'json' ? size - 4 : size - 2, fontWeight: 600,
    }}>{label}</span>
  );
}
